import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";
import { pub } from "@/lib/api";
import { HeaderLogo } from "@/components/Brand";
import { PoweredBy, Spinner, PracticeBanner } from "@/components/Layout";
import { TotalsBlock } from "@/components/CartSheet";

const PassCard = ({ p }) => (
  <div className={`rounded-3xl border-2 bg-white p-5 text-center ${p.used ? "border-ready" : "border-brand"}`} data-testid={`pass-card-${p.code}`}>
    <div className="font-heading text-lg font-extrabold">{p.ticket_name}</div>
    <div className="text-sm">{p.holder}</div>
    <div className="mx-auto my-4 w-fit rounded-2xl bg-white p-3"><QRCodeSVG value={p.code} size={210} fgColor="#1F2430" level="M" /></div>
    <div className="font-mono text-lg tracking-[0.25em]" data-testid="pass-code">{p.code}</div>
    <div className={`mt-2 inline-block rounded-full px-3 py-1 text-xs font-bold ${p.used ? "bg-ready text-ink" : "bg-brand text-white"}`} data-testid="pass-status">{p.used ? "Checked in" : "Valid · scan once at the door"}</div>
  </div>
);

export default function PassPage() {
  const { regId } = useParams();
  const [r, setR] = useState(null);
  useEffect(() => {
    let alive = true;
    const load = () => pub.get(`/registrations/${regId}`).then((x) => alive && setR(x.data)).catch(() => {});
    load();
    const t = setInterval(load, 4000);
    return () => { alive = false; clearInterval(t); };
  }, [regId]);
  if (!r) return <Spinner />;
  return (
    <div className="min-h-screen bg-brand-pale" data-testid="pass-page">
      <header className="flex h-14 items-center bg-white px-4"><HeaderLogo className="h-6" /></header>
      {r.practice && <PracticeBanner text="PRACTICE PASS — Stripe test card, no real money moved" testid="pass-practice-banner" />}
      <main className="mx-auto max-w-md px-4 py-8">
        <div className="eyebrow">LineGone entry pass</div>
        <h1 className="text-3xl font-black" data-testid="pass-event-name">{r.event.name}</h1>
        <p className="text-sm">{r.event.date} · {r.event.time} · {r.event.location}</p>
        {r.status === "pending_payment" ? <p className="mt-6 rounded-2xl bg-white p-4 font-semibold" data-testid="pass-pending">Confirming your payment… your pass appears here in a moment.</p> :
          <div className="mt-6 grid gap-4">{r.passes.map((p) => <PassCard key={p.code} p={p} />)}</div>}
        {r.totals.total_cents > 0 && <div className="mt-5 rounded-2xl bg-white p-4"><TotalsBlock t={r.totals} testPrefix="pass" /></div>}
        <p className="mt-4 text-center text-sm">Screenshot this page or check your email for a copy.</p>
        <PoweredBy />
      </main>
    </div>
  );
}
